import React from 'react';

const Divider = () => (<li className="divider" />);

export default Divider;
